import { MAX_RANK_TIER, PRESTIGE_NAME, PRESTIGE_STEP, RANKS } from "../content/ranks";

export type RankStatus = {
  tier: number;
  name: string;
  prestige: number; // 0 through tier 12, 1+ beyond Golden Voice
  clarityFloor: number;
  clarityCeil: number;
  progress: number; // 0..1 within the current tier/prestige band
};

export function rankFor(clarity: number): RankStatus {
  let current = RANKS[0]!;
  let next: (typeof RANKS)[number] | undefined = RANKS[1];
  for (const rank of RANKS) {
    if (clarity >= rank.clarity) current = rank;
  }
  next = RANKS.find((r) => r.clarity > current.clarity);

  if (next) {
    return {
      tier: current.tier,
      name: current.name,
      prestige: 0,
      clarityFloor: current.clarity,
      clarityCeil: next.clarity,
      progress: (clarity - current.clarity) / (next.clarity - current.clarity),
    };
  }

  // Beyond the last named rank: prestige tail, +PRESTIGE_STEP per star.
  // Landing exactly on the rank's own threshold is prestige 0 (no stars yet);
  // every full PRESTIGE_STEP past it earns one more.
  const overflow = clarity - current.clarity;
  const prestige = overflow <= 0 ? 0 : Math.ceil(overflow / PRESTIGE_STEP);
  const floor = current.clarity + Math.max(0, prestige - 1) * PRESTIGE_STEP;
  const ceil = floor + PRESTIGE_STEP;
  return {
    tier: MAX_RANK_TIER,
    name: prestige === 0 ? PRESTIGE_NAME : `${PRESTIGE_NAME} ${"★".repeat(prestige)}`,
    prestige,
    clarityFloor: floor,
    clarityCeil: ceil,
    progress: (clarity - floor) / (ceil - floor),
  };
}

/** Harmonic count for the generated rank crest — grows with tier, then
    keeps growing with prestige so the mark never stops getting richer. */
export function crestHarmonics(status: RankStatus): number {
  return status.tier + status.prestige;
}
